import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

const HomeRoute = () => <Outlet />;

export const Route = createFileRoute("/study-group/$study-group-id/home")({
  beforeLoad: ({ location, params }) => {
    if (location.pathname.endsWith("/home")) {
      throw redirect({
        to: "/study-group/$study-group-id/stream",
        params: { "study-group-id": params["study-group-id"] },
        replace: true,
      });
    }
  },
  component: HomeRoute,
});
